import { Loader2 } from "lucide-react";
import Text from "../components/main/Text"
import '../utils/GlobalStyles.css';

function Loading()
{
    return (
        <div className = 'centered' style = {{ gap: '30px' }}>
            <Text text = 'Loading...' fontSize = {45} />
            <Loader2 size = {45} color = '#4A4D4E' className = 'icon-spin' />
        </div>
    )
}

export default Loading;
